/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EventSummaryRoom_attendees = ReadonlyArray<{
    readonly displayName: string | null;
    readonly urnValue: string;
    readonly " $refType": "EventSummaryRoom_attendees";
}>;
export type EventSummaryRoom_attendees$data = EventSummaryRoom_attendees;
export type EventSummaryRoom_attendees$key = ReadonlyArray<{
    readonly " $data"?: EventSummaryRoom_attendees$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"EventSummaryRoom_attendees">;
}>;



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true
    },
    "name": "EventSummaryRoom_attendees",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayName",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "urnValue",
            "storageKey": null
        }
    ],
    "type": "Attendee",
    "abstractKey": null
} as any;
(node as any).hash = '66105e565deceb08b91273f49910a0ef';
export default node;
